
import { useState, useEffect } from 'react';

interface UseFormStateReturn {
  answer: string;
  setAnswer: (value: string) => void;
  name: string;
  setName: (value: string) => void;
  title: string;
  setTitle: (value: string) => void;
  company: string;
  setCompany: (value: string) => void;
  photoUrl: string;
  setPhotoUrl: (value: string) => void;
  wordCount: number;
}

export const useFormState = (): UseFormStateReturn => {
  const [answer, setAnswer] = useState('');
  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [company, setCompany] = useState('');
  const [photoUrl, setPhotoUrl] = useState('');
  const [wordCount, setWordCount] = useState(0);

  useEffect(() => {
    const words = answer.trim() ? answer.trim().split(/\s+/).length : 0;
    setWordCount(words);
  }, [answer]);

  return {
    answer,
    setAnswer,
    name,
    setName,
    title,
    setTitle,
    company,
    setCompany,
    photoUrl,
    setPhotoUrl,
    wordCount
  };
};
